import { useQuery } from '@tanstack/react-query'

import { listAccountIntegrations } from 'common/api/api'

import { cepIntegrationsKeys } from '../queryKeys/integrationsKeys'

const useListAccountsIntegrationQuery = (
  accountId: string,
  isEnabled: boolean = true
) => {
  const getIntegrationsQuery = useQuery(
    cepIntegrationsKeys.listAccountCepIntegrations(accountId),
    () => listAccountIntegrations(accountId),
    { enabled: isEnabled }
  )
  return getIntegrationsQuery
}

export default useListAccountsIntegrationQuery
